module.exports = __webpack_public_path__ + "static/media/11.c59a59fc.jpg";